module.exports = __webpack_public_path__ + "assets/polylang.ace1936d.svg";